import Vue from 'vue'
import filterMenuType from './filterMenuType'
let obj = {
  filterMenuType,
}
for(let i in obj){
  Vue.filter(i,obj[i])
}
